import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    heartbeatInfos: {},
    heartbeats: [], //all the heartbeats for this user
    heartbeatApps: {}, // all the app objects of the heartbeat- by Id
    heartbeatTrack: {} //Info for the dashboard
  },
  getters: {
    heartbeatInfos(state) {
      return state.heartbeatInfos;
    },
    heartbeats(state) {
      return state.heartbeats;
    }
  },
  actions: {
    /********* INVITES ***/
    getSuggestedProfileNames({ commit }, { profile, amount }) {
      return new Promise((res, rej) => {
        //const db = firebase.firestore();
        let suggestions = [];
        //@ToDo- improve this algorithm
        //Complete a search
        let i = 0;

        while (i < amount) {
          let suggestion =
            profile.firstname && profile.lastname
              ? `${profile.firstname}${profile.lastname}`
              : "";
          if (i > 0) suggestion = `${suggestion}${i}`;

          //Strip any non-alphanumerics
          suggestion = suggestion.replace(/[^0-9a-z]/gi, "");

          suggestions.push(suggestion.toLowerCase());
          i++;
        }
        res(suggestions);
      });
    },
    setProfileNameForProfile({ commit }, { profile, profileName, ip }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();

        let _userRef = db.collection("users").doc(profile.userId);

        _userRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              //update heartbeat
              // @todo Check for hb in the future

              let heartBeatProfile = {
                _created_at: new Date(),
                profileName: profileName,
                ip: ip
              };

              return _userRef
                .update({
                  _created_at: new Date(),
                  heartbeat: heartBeatProfile
                })
                .then(resp => {
                  console.log("Document successfully updated!");
                  res(true);
                })
                .catch(error => {
                  rej(error);
                });
            }
          })
          .catch(function(error) {
            console.error("Error in getting heartbeats: ", error);
            rej(error);
          });
      });
    },
    getHeartbeatsForUser({ commit, state }, { user }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let _heartbeatRef = db
          .collection("users")
          .doc(user.uid)
          .collection("lists")
          .doc("__heartbeats");

        _heartbeatRef
          .get()
          .then(function(doc) {
            if (
              doc.exists &&
              doc.data().heartbeats &&
              doc.data().heartbeats.length
            ) {
              commit("SET_HEARTBEATS", doc.data().heartbeats);
              res(doc.data().heartbeats);
            } else {
              res([]);
            }
          })
          .catch(function(error) {
            console.error("Error in getting heartbeats: ", error);
            rej(error);
          });
      });
    },
    getInviteByCode({ commit }, { inviteCode, email }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let invitesRef = db.collection("invites");
        let invite = {};
        invitesRef
          .where("inviteCode", "==", inviteCode)
          .where("rec.email", "==", email)
          .where("status", "==", "pending")
          .get()
          .then(querySnapshot => {
            const doc = querySnapshot.docs[0];
            if (doc) {
              res({ ...doc.data(), docId: doc.id });
            } else {
              res(null);
            }
          })
          .catch(error => {
            rej(error);
            console.log("Error getting document: ", error);
          });
      });
    },
    updateFamilyInvite({ commit }, { inviteDocId, status, updatedBy }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        console.log("Updating Invite");
        let invitationRef = db.doc(`invites/${inviteDocId}`);
        invitationRef.get().then(doc => {
          if (doc.exists) {
            let _status_date = null;
            switch (status) {
              case "accepted":
                _status_date = "_accepted_at";
                break;
              case "rejected":
                _status_date = "_rejected_at";
                break;
              case "cancelled":
                _status_date = "_cancelled_at";
                break;
              default:
                _status_date = "_status_updated_at";
                break;
            }
            let data = doc.data();
            return invitationRef
              .update({
                _updated_at: new Date(),
                status: status, //accepted | rejected | cancelled
                [_status_date]: new Date(),
                _updated_by: data._updated_by
                  ? [...data._updated_by, ...updatedBy]
                  : [updatedBy]
              })
              .then(() => {
                res(true);
              });
          } else {
            res(false);
          }
        });
      });
    },
    responseToInvite({ commit }, { reqUID, profile, inviteCode, hasAccepted }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let familyRef = db.doc(`users/${reqUID}/lists/__family`);

        familyRef
          .get()
          .then(doc => {
            if (doc.exists && doc.data().family && doc.data().family.length) {
              let family = doc.data().family;

              //Find invitation
              let familyMembers = family.filter(aMember => {
                return (
                  aMember.status &&
                  aMember.status.inviteCode &&
                  aMember.status.inviteCode === inviteCode
                );
              });

              //Check if status is pending
              //Check if expired
              //Check is canceled
              const familyMember =
                Array.isArray(familyMembers) && familyMembers[0]
                  ? familyMembers[0]
                  : null;
              if (familyMember && familyMember.status) {
                //found - now modify
                familyMember.status.status = hasAccepted
                  ? "active"
                  : "inactive";
                //active, inactive, blocked

                if (hasAccepted) {
                  familyMember.status._accepted_at = new Date();
                  //Update User Info to the lates
                  if (familyMember.user) {
                    familyMember.user._updated_at = new Date();
                    familyMember.user.firstname = profile.firstname;
                    familyMember.user.lastname = profile.lastname;
                    familyMember.user.userId = profile.userId;

                    //Email Check- //in case different than requested
                    if (familyMember.user.email !== profile.email) {
                      familyMember.user.z_email = familyMember.user.email;
                      familyMember.user.email = profile.email;
                    }
                  }
                } else {
                  familyMember.status._rejected_at = new Date();
                }
                return familyRef.update({
                  _updated_at: new Date(),
                  family: family
                });
              } else {
                theInvitation.status._rejected_at = new Date();
              }

              theInvitation.status._updated_at = new Date();
            } else {
              res({ response: false, msg: "Invite Invalid" }); //expired/cancelled
            }
          })
          .then(() => {
            if (hasAccepted) {
              console.log("Updating HeartBeats");
              let heartBeatRef = db.collection("users").doc(reqUID);

              return heartBeatRef
                .get()
                .then(doc => {
                  let profileDoc = { ...doc.data() };
                  // now update the user info for this heartbeat

                  const heartBeatProfileSlug =
                    profileDoc.heartbeat && profileDoc.heartbeat
                      ? profileDoc.heartbeat.profileName
                      : "invalid";
                  const aHeartBeat = {
                    _created_at: new Date(),
                    imgURL: profileDoc.imgURL ? profileDoc.imgURL : null,
                    name: `${profileDoc.firstname} ${profileDoc.lastname}`,
                    slug: heartBeatProfileSlug,
                    uid: reqUID
                  };

                  let __heartbeatsRef = db
                    .collection("users")
                    .doc(profile.userId)
                    .collection("lists")
                    .doc("__heartbeats");

                  __heartbeatsRef
                    .get()
                    .then(doc => {
                      if (doc.exists) {
                        __heartbeatsRef.update({
                          _updated_at: new Date(),
                          heartbeats: [...doc.data().heartbeats, aHeartBeat]
                        });
                      } else {
                        __heartbeatsRef.set({
                          _created_at: new Date(),
                          heartbeats: [aHeartBeat]
                        });
                      }
                      res(true);
                    })
                    .catch(function(error) {
                      console.error("Error updating document: ", error);
                      rej(error);
                    });
                })
                .catch(function(error) {
                  console.error("Error in getting family: ", error);
                  rej(error);
                });
            } else {
              res(true);
            }
          });
      });
    },
    verifyHeartBeatAccess({ commit }, { profile, heartbeat }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const _familyRef = db.doc(`users/${heartbeat.uid}/lists/__family`);
        _familyRef
          .get()
          .then(doc => {
            if (doc.exists) {
              const family = doc.data().family ? doc.data().family : [];

              if (heartbeat.uid === profile.userId) {
                commit("SET_HEARTBEAT_FAMILY", {
                  uid: heartbeat.uid,
                  family: family
                });
                res({
                  _isApproved: true,
                  status: "none",
                  family: family
                });
              } else {
                let familyMember = family.filter(family => {
                  return family.user && profile
                    ? family.user.userId === profile.userId
                    : false;
                });

                if (familyMember.length === 1) {
                  if (
                    familyMember[0].status.status === "active" ||
                    heartbeat.uid === profile.userId //it is this user
                  ) {
                    commit("SET_HEARTBEAT_FAMILY", {
                      uid: heartbeat.uid,
                      family: family
                    });
                    res({
                      _isApproved: true,
                      status: familyMember[0].status,
                      family: family
                    });
                  } else {
                    res({
                      _isApproved: false,
                      status: familyMember[0].status
                    });
                  }
                } else {
                  res({
                    _isApproved: false,
                    status: "none"
                  });
                }
              }
            } else {
              if (heartbeat.uid === profile.userId) {
                res({
                  _isApproved: true,
                  status: "none",
                  family: []
                });
              } else {
                res({
                  _isApproved: false,
                  status: "none"
                });
              }
            }
          })
          .catch(err => {
            rej(err);
          });
      });
    },
    getAppsForHeartBeat({ commit }, { heartbeat }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const _appsRef = db.doc(`users/${heartbeat.uid}/lists/__apps`);

        _appsRef
          .get()
          .then(doc => {
            if (doc.exists) {
              const apps = doc.data().apps ? doc.data().apps : [];

              if (Array.isArray(apps)) {
                commit("SET_HEARTBEAT_APPS", {
                  uid: heartbeat.uid,
                  apps: apps
                });
                res(apps);
              } else {
                res([]);
              }
            } else {
              res([]);
            }
          })
          .catch(e => {
            res([]);
          });
      });
    },
    communicateMessageSend({ commit }, { heartbeat, message, createdBy }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const timestamp = Date.now();
        const communicateMessagesRef = db
          .doc(`users/${heartbeat.uid}/heartbeat/communicate`)
          .collection("messages");

        communicateMessagesRef
          .doc(timestamp.toString())
          .set({
            _created_at: new Date(),
            _created_by: createdBy,
            message: message
          })
          .then(() => {
            res(true);
          })
          .catch(function(error) {
            console.error(error);
            rej(error);
          });
      });
    },
    communicateMessageReceives({ commit }, { heartbeat }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const communicateMessagesRef = db.collection(
          `users/${heartbeat.uid}/heartbeat/communicate/messages`
        );

        return communicateMessagesRef
          .orderBy("_created_at", "desc")
          .limit(20) //get last 20
          .onSnapshot(
            querySnapshot => {
              let messages = [];

              querySnapshot.forEach(doc => {
                messages.push(doc.data());
              });

              commit("SET_HEARTBEAT_COMMUNICATE_MESSAGES", {
                uid: heartbeat.uid,
                messages: messages
              });
              res(true);
            },
            error => {
              rej(error);
            }
          );
      });
    },
    /****** Tiles  ***********/
    getTiles({ commit }, { heartbeat }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const _tilesRef = db.doc(`users/${heartbeat.uid}/heartbeat/tiles`);

        _tilesRef
          .get()
          .then(doc => {
            if (doc.exists) {
              commit("SET_HEARTBEAT_TILES", {
                uid: heartbeat.uid,
                tiles: doc.data()
              });
              res(doc.data());
            } else {
              res([]);
            }
          })
          .catch(e => {
            res([]);
          });
      });
    },
    addUpdateTile({ commit }, { heartbeat, tileKey, tileObj, createdBy }) {
      debugger;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        tileObj._created_at = new Date();
        tileObj._created_by = createdBy;
        const tilesRef = db.doc(`users/${heartbeat.uid}/heartbeat/tiles`);
        tilesRef.get().then(doc => {
          if (doc.exists) {
            const tiles = doc.data().tiles ? doc.data().tiles : {};
            const updatedTiles = tiles[tileKey] ? [...tiles[tileKey], tileObj] : [tileObj];
            tiles[tileKey]= updatedTiles;

            return tilesRef
              .update({
                _updated_at: new Date(),
                tiles: tiles
              })
              .then(() => res(true));
          } else {
            return tilesRef
              .set({
                _created_at: new Date(),
                tiles: {
                  [tileKey]: [tileObj]
                }
              })
              .then((resp) => {
                console.log("successfully saved in tiles");
                res(resp);
              })
              .catch((err) => {
                rej(err)
              });
          }
        });
      });
    }
  },
  mutations: {
    SET_HEARTBEATS(state, heartbeats) {
      if (Array.isArray(heartbeats)) {
        state.heartbeats = heartbeats;
      }
    },
    SET_HEARTBEAT_APPS(state, { uid, apps }) {
      if (!state.heartbeatInfos[uid]) state.heartbeatInfos[uid] = {};
      state.heartbeatInfos[uid].apps = apps;
    },
    SET_HEARTBEAT_TILES(state, { uid, tiles }) {
      if (!state.heartbeatInfos[uid]) state.heartbeatInfos[uid] = {};
      state.heartbeatInfos[uid].tiles = tiles;

      //Refresh object- to make reactive
      state.heartbeatInfos[uid]={ ... state.heartbeatInfos[uid]}
      //state.heartbeatInfos = { ...state.heartbeatInfos };
    },
    SET_HEARTBEAT_FAMILY(state, { uid, family }) {
      if (!state.heartbeatInfos[uid]) state.heartbeatInfos[uid] = {};

      state.heartbeatInfos[uid].family = family;

      //Refresh object
      state.heartbeatInfos = { ...state.heartbeatInfos };
    },
    SET_HEARTBEAT_COMMUNICATE_MESSAGES(state, { uid, messages }) {
      debugger;
      if (!state.heartbeatInfos[uid]) state.heartbeatInfos[uid] = {};

      if (!state.heartbeatInfos[uid].communicate)
        state.heartbeatInfos[uid].communicate = {};

      if (!state.heartbeatInfos[uid].communicate.messages)
        state.heartbeatInfos[uid].communicate.messages = [];

      state.heartbeatInfos[uid].communicate.messages = messages;

      //Refresh object
      state.heartbeatInfos = { ...state.heartbeatInfos };
    }
  }
};
